import React from "react";
import styled from "styled-components";


const IconContainer = styled.span`
    display: flex;
    align-items: center;
`;
export interface ITimeIcon {
    style?: React.CSSProperties;
    fill: string;
  }

const TimeIcon: React.FC<ITimeIcon> = ({style, fill}) => {

    return(
        <IconContainer style={{...style}}>
            <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M8 8.00008H6.66667V6.66675C6.66667 6.29808 6.368 6.00008 6 6.00008C5.632 6.00008 5.33333 6.29808 5.33333 6.66675V8.66675C5.33333 9.03541 5.632 9.33342 6 9.33342H8C8.368 9.33342 8.6667 9.03541 8.6667 8.66675C8.6667 8.29808 8.368 8.00008 8 8.00008ZM6 13.1667C3.51867 13.1667 1.5 11.1481 1.5 8.66675C1.5 6.18541 3.51867 4.16675 6 4.16675C8.4813 4.16675 10.5 6.18541 10.5 8.66675C10.5 11.1481 8.4813 13.1667 6 13.1667ZM6.65867 2.70541C6.66 2.69141 6.66667 2.68075 6.66667 2.66675V2.00008H7.33333C7.70133 2.00008 8 1.70208 8 1.33341C8 0.964748 7.70133 0.666748 7.33333 0.666748H4.66667C4.29867 0.666748 4 0.964748 4 1.33341C4 1.70208 4.29867 2.00008 4.66667 2.00008H5.33333V2.66675C5.33333 2.68075 5.34 2.69141 5.34133 2.70541C2.342 3.03475 0 5.58142 0 8.66675C0 11.9754 2.692 14.6667 6 14.6667C9.308 14.6667 12 11.9754 12 8.66675C12 5.58142 9.658 3.03475 6.65867 2.70541Z" fill={fill}/>
            </svg>
        </IconContainer>
    )
}

export default TimeIcon;